import { Badge } from "@bruntworkwear-apps/ui";
import { quantity } from "@/shared/lib";
import type { PoSummary } from "@/shared/api";
import styles from "../PoTable.module.css";

/** Units the tracker could not account for, if any. */
export function shortfallOf(order: PoSummary): number {
  if (!order.allocation) return 0;
  return Math.max(0, order.allocation.requested_quantity - order.allocation.allocated_quantity);
}

/**
 * How much of the receipt quantity the tracker explained.
 *
 * A private sub-view of PoTable, sharing its stylesheet.
 */
export function AllocationCellView({ order }: { order: PoSummary }) {
  if (!order.allocation) return <Badge tone="danger">no match</Badge>;

  const missing = shortfallOf(order);

  return (
    <span className={styles.allocation}>
      {quantity(order.allocation.allocated_quantity)} of{" "}
      {quantity(order.allocation.requested_quantity)}
      {missing > 0 && <span className={styles.shortfall}> ({quantity(missing)} short)</span>}
    </span>
  );
}
